import * as z from "zod/v4";

export const footerContactFormSchema = z.object({
	name: z.string().min(1),
	email: z.email().transform((val) => val.toLowerCase()),
	phone: z.string().min(1),
	message: z.string().min(1),
	notificationEmail: z.email(),
	turnstileToken: z.string(),
	pageUrl: z.url(),
	routeId: z.string(),
	utmSource: z.string(),
	utmMedium: z.string(),
	utmCampaign: z.string(),
	utmContent: z.string(),
	utmTerm: z.string()
});

export type FooterContactFormSchema = z.infer<typeof footerContactFormSchema>;

export const footerContactFormClientSchema = footerContactFormSchema.pick({
	name: true,
	email: true,
	phone: true,
	message: true,
	turnstileToken: true
});
